import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useModal } from "@/hooks";
import styles from "@/styles/Modal.module.scss";
import Image from "next/legacy/image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CvvModal() {
  const {
    hideModal
  } = useModal();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.cvv,
    children: [/*#__PURE__*/_jsx("h4", {
      className: styles.title,
      children: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3068\u306F"
    }), /*#__PURE__*/_jsx("div", {
      className: styles.image,
      children: /*#__PURE__*/_jsx(Image, {
        src: "/images/cvv_card.png",
        width: 240,
        height: 150
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
      className: styles.description,
      children: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3068\u306F\u3001\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u88CF\u9762\u306B\u8A18\u8F09\u3055\u308C\u305F\u672B\u5C3E3\u6841\u3082\u3057\u304F\u306F4\u6841\u306E\u6570\u5B57\u3067\u3059\u3002"
    }), /*#__PURE__*/_jsx("div", {
      className: `${styles.btnArea} ${styles.multiple} ${styles.button}`,
      children: /*#__PURE__*/_jsx(ButtonMultiClick, {
        borderGray: true,
        fontFixed: true,
        large: true,
        onClick: hideModal,
        children: "\u9589\u3058\u308B"
      })
    })]
  });
}